import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateDocumentRequest {
    originFileName: string;
    contentType: string;
    destinationFileName: string;
    isExpiryTracked = false;
    expiresAt = '';
}